export default function Map() {
    return (
        <div style={{ width: '100%', margin: '0' }}>
            <iframe
                title="WASA Map Directions"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3871.994482382768!2d33.799219!3d-13.958934!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1921d35cf98c96db%3A0xec23c3d21553cbbf!2sWork%20and%20Study%20Abroad!5e0!3m2!1sen!2sus!4v1737828544870!5m2!1sen!2sus"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
    );
}